module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-content', [_c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-xsmall-size-100"
  }, [_c('md-field', [_c('label', [_vm._v("请输入APPID/ID/产品名称")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  })], 1)], 1)]), _vm._v(" "), _c('md-content', [(_vm.plist.length > 0) ? _c('md-table', [_c('md-table-row', [_c('md-table-head', [_vm._v("发行游戏名称")]), _vm._v(" "), _c('md-table-head', [_vm._v("更多")])], 1), _vm._v(" "), _vm._l((_vm.plist), function(item, index) {
    return _c('md-table-row', [_c('md-table-cell', {
      nativeOn: {
        "click": function($event) {
          return _vm.goDetail(item.name)
        }
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('md-table-cell', {
      nativeOn: {
        "click": function($event) {
          return _vm.goDetail(item.name)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "width": "50px"
      }
    }, [_vm._v("详请")])])], 1)
  })], 2) : _c('md-table', [_c('md-table-row', [_c('md-table-head', [_vm._v("暂无信息")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// D:/发行部门文件/后台管理系统文件/~/vue-loader/lib/template-compiler?{"id":"data-v-5c9a8364"}!D:/发行部门文件/后台管理系统文件/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Plist.vue
// module id = 527
// module chunks = 0